import { Dialog, DialogContent, Grid } from '@material-ui/core';
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Texto from '@infotrack/presentacion-componentes/texto';
import { manejadorDialogoGlobal } from '@infotrack/presentacion-utilitarios/manejadoresComponentes';

import IDocumentoConsultaGeneral, {
    DOCUMENTO_CONSULTA_GENERAL_POR_DEFECTO,
} from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoConsultaGeneral';
import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import TiposProceso from 'Infotrack@Modelos/negocioRefactor/enumeraciones/TiposProceso';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import DetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormularioTabla/DetallesFormulario';
import EstadosDetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormulario/enumeraciones';
import DocumentoBuscador from 'Infotrack@Transversales/componentes/DocumentoBuscador/DocumentoBuscador';
import DocumentoValorTotal from 'Infotrack@Transversales/componentes/DocumentoValorTotal/DocumentoValorTotal';
import { EstadosFormularioDocumento } from 'Infotrack@Transversales/componentes/FormularioDocumento/enumeraciones';
import FormularioDocumento, {
    IEntidadesFormularioDocumento,
} from 'Infotrack@Transversales/componentes/FormularioDocumento/FormularioDocumento';

import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import TablaDetalles from 'Infotrack@Transversales/componentes/TablaDetalles/TablaDetalles';
import TablaDetallesPlantilla from 'Infotrack@Transversales/componentes/TablaDetallesPlantilla/TablaDetallesPlantilla';

import {
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_DOCUMENTO_BASE,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION,
    CAMPOS_EDITABLES_DETALLES_PLANTILLA,
    CAMPOS_OCULTAR_DETALLES_FORMULARIO,
    CAMPOS_OCULTAR_DETALLES_PLANTILLA,
    CAMPOS_OCULTAR_DETALLES_TABLA,
    CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO,
    ENTIDADES_DOCUMENTO_POR_DEFECTO,
} from './constantes';
import EntidadesDetalleCM from './controladorModelo/EntidadesDetalleCM';
import EntidadesDocumentoCM from './controladorModelo/EntidadesDocumentoCM';
import EntradaInventarioCM from './controladorModelo/EntradaInventarioCM';
import { EstadosModalEntradaInventario } from './enumeraciones';
import { estadoActivo } from 'Infotrack@Transversales/constantes/ConstantesEstados';
import DocumentoFirma from 'Infotrack@Transversales/componentes/DocumentoFirma/DocumentoFirma';
import Etapas from 'Infotrack@Modelos/negocioRefactor/enumeraciones/Etapas';

interface IModalEntradaInventarioProps {
    cerrar: () => void;
    documentoId: string | null;
    establecerDocumentoId: (documentoId: string) => void;
    estado: EstadosModalEntradaInventario;
    descargarDocumentoPdf: (documento: IDocumentoConsultaGeneral) => any;
    cambiarEstado: () => void;
}

const ModalEntradaInventario: FunctionComponent<IModalEntradaInventarioProps> = ({
    cerrar,
    documentoId,
    establecerDocumentoId,
    estado,
    descargarDocumentoPdf,
    cambiarEstado,
}) => {

    const DOCUMENTO_DETALLE_POR_DEFECTO: IDocumentoDetalle = {
        CantidadEntregada: 0,
        CantidadRecibida: 0,
        CantidadSolicitada: 0,
        DocumentoDetalleId: '',
        DocumentoId: '',
        EmpresaId: '',
        Estado: 0,
        FechaVencimiento: '',
        Lote: '',
        Serial: '',
        Valor: 0,
        PesoFraccion: 0,
        PesoFraccionRecibido: 0,
    };
    const entidadesDocumentoCM = useMemo(() => new EntidadesDocumentoCM(), []);
    const entradaInventarioCM = useMemo(() => new EntradaInventarioCM(), []);
    const entidadesDetalleCM = useMemo(() => new EntidadesDetalleCM(), []);

    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    const idAgencia = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.agenciaActual!.IdAgencia);
    const idUsuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdUsuario);
    const usuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion);
    const idAplicacion = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdAplicacion);

    const [entidadesDocumento, setEntidadesDocumento] = useState<Partial<IEntidadesFormularioDocumento>>(
        ENTIDADES_DOCUMENTO_POR_DEFECTO
    );
    const [documento, setDocumento] = useState<IDocumentoConsultaGeneral | null>(null);
    const [etapasSiguientes, setEtapasSiguientes] = useState<IEtapas[]>([]);
    const [entidadesDetalle, setEntidadesDetalle] = useState<{
        divisionesDestino: IBodegaDivisiones[];
    }>({ divisionesDestino: [] });
    const [ejecutarConsultarDocumentos, setEjecutarConsultarDocumentos] = useState<boolean>(false);
    const [detalles, setDetalles] = useState<IDocumentoDetalleConsultaGeneral[]>([]);
    const [detalleInicialEdicion, setDetalleInicialEdicion] = useState<IDocumentoDetalle | null>(null);
    const [detallesDocumentoBase, setDetallesDocumentoBase] = useState<IDocumentoDetalleConsultaGeneral[]>([]);
    const [refrescarCampoDocumentoBase, setRefrescarCampoDocumentoBase] = useState<boolean>(false);
    const [abrirModalActa, setAbrirModalActa] = useState<boolean>(false);
    const [etapaSeleccionada, setEtapaSeleccionada] = useState<number>(0);

    useEffect(() => {
        alCambiarEstado();
    }, [estado]);

    useEffect(() => {
        if (documento) alEstablecerDocumento();
    }, [documento]);

    const alCambiarEstado = async () => {
        if (estado === EstadosModalEntradaInventario.CERRADO) {
            setDocumento(null);
            setDetalles([]);
            setEntidadesDocumento(ENTIDADES_DOCUMENTO_POR_DEFECTO);
            setEtapasSiguientes([]);
            setEntidadesDetalle({ divisionesDestino: [] });
            setDetalleInicialEdicion(null);
            setDetallesDocumentoBase([]);
        }
        if (estado === EstadosModalEntradaInventario.CREACION) {
            await consultarEntidadesDocumento();
            setDetallesDocumentoBase([]);
        }
        if (
            estado === EstadosModalEntradaInventario.EDICION ||
            estado === EstadosModalEntradaInventario.VISUALIZACION
        ) {
            await consultarDocumento(documentoId!);
        }
    };

    const consultarEntidadesDocumento = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumento(
            idEmpresa,
            idAgencia,
            usuario!.NombrePerfil! !== "Administrador" ? idUsuario : "",
            estadoActivo
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarEntidadesDocumentoEdicion = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumentoEdicion(
            documento!.BodegaDestino!,
            idEmpresa,
            idAgencia,
            usuario!.NombrePerfil! !== "Administrador" ? idUsuario : "",
            TiposProceso.ENTRADA_DE_INVENTARIO,
            estadoActivo
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarDocumento = async (documentoIdConsultar: string) => {
        if (documentoIdConsultar !== null) {
            const documentoConsultado = await entradaInventarioCM.consultarEncabezadoDocumento({
                DocumentoId: documentoIdConsultar,
            });
            establecerDocumentoId(documentoConsultado.DocumentoId);
            await setDocumento(documentoConsultado);
        }
    };

    const alEstablecerDocumento = async () => {
        if (estado === EstadosModalEntradaInventario.CREACION) {
            if (documento!.DocumentoId) {
                establecerDocumentoId(documento!.DocumentoId);
                await consultarEtapasSiguientes();
                await consultarEntidadesDetalle();
                await consultarDetallesDocumentoBase();
            }
        }
        if (estado === EstadosModalEntradaInventario.EDICION) {
            await consultarEtapasSiguientes();
            await consultarEntidadesDetalle();
            await consultarDetallesDocumentoBase();
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
        if (estado === EstadosModalEntradaInventario.VISUALIZACION) {
            await consultarEntidadesDetalle();
            await consultarDetallesDocumentoBase();
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
    };

    const consultarEntidadesDetalle = async () => {
        const entidadesDetalleConsultadas = await entidadesDetalleCM.consultarEntidadesDetalle(
            documento!.BodegaDestino!,
            documento!.TipoDocumentoId,
            idEmpresa
        );
        setEntidadesDetalle(entidadesDetalleConsultadas);
    };

    const consultarDetalles = async () => {
        if (documentoId !== null) {
            const detallesConsultados = await entradaInventarioCM.consultarDetallesDocumento({
                DocumentoId: documentoId!,
            });
            consultarDetallesDocumentoBase();
            setDetalles(detallesConsultados);
        }
    };

    const consultarDetallesDocumentoBase = async () => {
        const detallesDocumentoBaseConsultados = await entradaInventarioCM.consultarDetallesDocumento({
            DocumentoId: documento!.DocumentoPredecesorId,
        });
        setDetallesDocumentoBase(detallesDocumentoBaseConsultados);
    };

    const consultaDocumentoBase = async (codigoDocumentoBase: string) => {
        const documentoBase = await entradaInventarioCM.consultarDocumentoBase({
            CodigoDocumento: codigoDocumentoBase,
            IdAgencia: usuario!.NombrePerfil! !== "Administrador" ? idAgencia : "",
            IdEmpresa: idEmpresa
        });
        if (documentoBase) {
            setDocumento(mapearDocumentoBase(documentoBase));
            consultarTipoDocumento(documentoBase.BodegaDestino!,"BodegaDestino")
        } else {
            setRefrescarCampoDocumentoBase(true);
            setRefrescarCampoDocumentoBase(false);
        }
        return documentoBase;
    };

    const mapearDocumentoBase = (documentoBase: IDocumento): IDocumentoConsultaGeneral => {
        return {
            ...DOCUMENTO_CONSULTA_GENERAL_POR_DEFECTO,
            BodegaOrigen: documentoBase.BodegaOrigen,
            ClienteId: documentoBase.ClienteId,
            CodigoDocumentoPredecesor: documentoBase.CodigoDocumento,
            CondicionComercial: documentoBase.CondicionComercial,
            DireccionEntrega: documentoBase.DireccionEntrega,
            DocumentoPredecesorId: documentoBase.DocumentoId,
            DocumentoRelacionado: documentoBase.DocumentoRelacionado,
            FechaEntrega: documentoBase.FechaEntrega,
            Observacion: documentoBase.Observacion,
            BodegaDestino:documentoBase.BodegaDestino,
            ProveedorId:documentoBase.ProveedorId
        };
    };

    const consultarEtapasSiguientes = async () => {
        const etapasSiguientesConsultadas = await entradaInventarioCM.consultarEtapas(documento!.DocumentoId);
        setEtapasSiguientes(etapasSiguientesConsultadas);
    };

    const crearDocumento = async (documentoCrear: IDocumento) => {
        documentoCrear.DocumentoId = generateGUID();
        const respuesta = await entradaInventarioCM.guardarEncabezado(mapearDocumentoCrear(documentoCrear));
        if (respuesta.Resultado) {
            cambiarEstado();
            await consultarDocumento(respuesta.Entidades[0].DocumentoId);
        }
    };

    const mapearDocumentoCrear = (documentoCrear: IDocumento): IDocumento => {
        return {
            ...documentoCrear,
            EmpresaId: idEmpresa,
            AgenciaId: idAgencia,
        };
    };

    const editarDocumento = async (documentoEditar: IDocumento) => {
        const respuesta = await entradaInventarioCM.editarEncabezado(documentoEditar);
        if (respuesta.Resultado) await consultarDocumento(documento!.DocumentoId);
    };

    const cambiarEtapa = async (etapaId: number) => {
        if ( await consultasAccionesTipoDocumento(documento!.TipoDocumentoId,etapaId) === false ) {
            manejadorDialogoGlobal({ estado: false });
          
            const cambioEtapaExitoso = await entradaInventarioCM.cambiarEtapa({ ...documento!, EtapaId: etapaId }, idUsuario);
            if (cambioEtapaExitoso) {
                await consultarDocumento(documento!.DocumentoId);
                if(etapaId === Etapas.FINALIZADA) entradaInventarioCM.guardarDocumentoFirma({ AplicacionId: idAplicacion,DocumentoId: documentoId!, FirmaBase64: "" })
            }
        } else {
            setEtapaSeleccionada(etapaId)
        }

    };

    const confirmarCambiarEtapa = async (etapaId: number) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => cambiarEtapa(etapaId),
            estado: true,
            mensaje: <Texto id={'etapas.CambioEtapa'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const agregarDetalles = async (detallesAgregar: IDocumentoDetalle[]) => {
        return entradaInventarioCM.guardarDetalle(
            detallesAgregar.map((detalle) => ({
                ...detalle,
                CantidadSolicitada: 0,
                DocumentoDetalleId: generateGUID(),
                DocumentoDetallePredecesorId: detalle.DocumentoDetalleId,
                DocumentoId: documento!.DocumentoId,
            }))
        );
    };

    const editarDetalle = async (detalle: IDocumentoDetalle) => {
        const respuesta = await entradaInventarioCM.editarDetalle(detalle);
        if (respuesta) {
            await consultarDetallesDocumentoBase();
            await consultarDetalles();
        }
        return respuesta;
    };

    const eliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({ estado: false });
        const respuesta = await entradaInventarioCM.eliminarDetalle(detalle);
        if (respuesta) {
            alEliminarDetalle();
            await setDetalleInicialEdicion(DOCUMENTO_DETALLE_POR_DEFECTO);
        }
    };
    const confirmarEliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarDetalle(detalle),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const alEliminarDetalle = async () => {
        await setDetalleInicialEdicion(null);
        await consultarDetallesDocumentoBase();
        await consultarDetalles();
    };

    const consultarTipoDocumento = async (idBodega: number, nombreNodega?: string) => {
        if (nombreNodega === 'BodegaDestino') {
            const tiposDocumentosBodega = await entidadesDocumentoCM.consultarTipoDocumento(idBodega, estadoActivo);
            setEntidadesDocumento({ ...entidadesDocumento, tiposDocumento: tiposDocumentosBodega });
        }
    };

    const generateGUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    const estadoDetallesFormulario = documento
        ? !documento.DocumentoPredecesorId && !detalleInicialEdicion
            ? EstadosDetallesFormulario.CREACION
            : EstadosDetallesFormulario.EDICION
        : EstadosDetallesFormulario.CREACION;


    const consultarItemsTabla = async (idItem: number) => {
        const items = await entidadesDetalleCM.consultarItem(
            idItem,
            idEmpresa
        );
        return items.itemsConsulta;
    };

    const consultasAccionesTipoDocumento = async (idTipoDocumento: number, idEtapa: number) => {
        debugger
        const acciones = await entidadesDocumentoCM.consultarAccionEtapaDocumentoFiltro(idTipoDocumento, idEtapa);
        if (acciones[0].EtapaDescripcion ==="Finalizado" && acciones[0].GenerarActa) {
            setAbrirModalActa(true)
            return true;
        }
        else {
            return false;
        }
    }

    const consultarFirmas = () => { }

    const guardarFirmas = async (firma: File) => {
        const reader = new FileReader();
        reader.onload = async function(event) {
            const base64 = (event.target!.result as string).split(',')[1]
            const cambioEtapaExitoso = await entradaInventarioCM.cambiarEtapa({ ...documento!, EtapaId: etapaSeleccionada, PersonaRelacionada:idUsuario },idUsuario);
            if (cambioEtapaExitoso) {
                manejadorDialogoGlobal({ estado: false });
                const respuesta = await entradaInventarioCM.guardarDocumentoFirma({ AplicacionId: idAplicacion,DocumentoId: documentoId!, FirmaBase64: base64 })
                if (cambioEtapaExitoso) {
                    await consultarDocumento(documento!.DocumentoId);
                    setAbrirModalActa(false);
                }
            }
        };
        reader.readAsDataURL(firma);
    }

    const cerrarDocumentoFirma = () => {
        setAbrirModalActa(false)
    }


    return (
        <Dialog open={estado !== EstadosModalEntradaInventario.CERRADO} maxWidth="lg">
            <ModalEncabezado
                cerrar={cerrar}
                titulo={
                    estado === EstadosModalEntradaInventario.CREACION ? (
                        <Texto id="ModalEntradaInventario.TituloCreacion" />
                    ) : estado === EstadosModalEntradaInventario.EDICION ? (
                        <Texto id="ModalEntradaInventario.TituloEdicion" />
                    ) : estado === EstadosModalEntradaInventario.VISUALIZACION ? (
                        <Texto id="ModalEntradaInventario.TituloVisualizacion" />
                    ) : (
                        undefined
                    )
                }
            />
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {(!documento || !documento.DocumentoId) && (
                            <DocumentoBuscador
                                consultaDocumentoBase={consultaDocumentoBase}
                                refrescarCampo={refrescarCampoDocumentoBase}
                                esEntradaDevolucion={false}
                            />
                        )}
                    </Grid>
                    {documento && (
                        <Grid item xs={12}>
                            <FormularioDocumento
                                cambiarEtapa={confirmarCambiarEtapa}
                                camposDeshabilitar={
                                    estado === EstadosModalEntradaInventario.CREACION
                                        ? CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO
                                        : CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION
                                }
                                camposOcultar={CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO}
                                documento={documento}
                                editarDocumento={editarDocumento}
                                entidadesDocumento={entidadesDocumento}
                                estado={
                                    !documento || !documento.DocumentoId
                                        ? EstadosFormularioDocumento.CREACION
                                        : (estado === EstadosModalEntradaInventario.CREACION &&
                                            documento &&
                                            documento.DocumentoId) ||
                                            estado === EstadosModalEntradaInventario.EDICION
                                            ? EstadosFormularioDocumento.EDICION
                                            : EstadosFormularioDocumento.VISUALIZACION
                                }
                                etapasSiguientes={etapasSiguientes}
                                guardarDocumento={crearDocumento}
                                descargarDocumentoPdf={descargarDocumentoPdf}
                                consultarTipoDocumento={consultarTipoDocumento}
                                mostrarModalEvidencia={true}
                                esTraslado={false}
                            />
                        </Grid>
                    )}

                    {documento && documento.DocumentoPredecesorId && (
                        <Grid item xs={12}>
                            <TablaDetallesPlantilla
                                agregarDetalles={agregarDetalles}
                                alAgregarDetalles={async () => {
                                    await consultarDetallesDocumentoBase();
                                    await consultarDetalles();
                                }}
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_PLANTILLA}
                                camposEditables={CAMPOS_EDITABLES_DETALLES_PLANTILLA}
                                deshabilitada={
                                    !documento ||
                                    !documento.ListaAcciones.PermiteAgregarDetalle ||
                                    estado === EstadosModalEntradaInventario.VISUALIZACION
                                }
                                detalles={detallesDocumentoBase}
                                entidades={entidadesDetalle}
                                tipoCantidad="CantidadRecibida"
                                titulo={
                                    <Texto
                                        fontWeight="bold"
                                        id="ModalEntradaInventario.TituloTablaDetallesDocumentoBase"
                                    />
                                }
                                asignarSerialesVisible={true}
                                seriadoConsulta={false}
                                manejaPeso={true}
                                esEntrada={true}
                            />
                        </Grid>
                    )}
                    {estado !== EstadosModalEntradaInventario.VISUALIZACION && (
                        <Grid item xs={12}>
                            <DetallesFormulario
                                agregarDetalles={agregarDetalles}
                                alAgregarDetalles={consultarDetalles}
                                alEditarDetalle={async () => {
                                    setDetalleInicialEdicion(null);
                                    await consultarDetalles();
                                }}
                                camposDeshabilitar={
                                    estadoDetallesFormulario === EstadosDetallesFormulario.EDICION ? ['ItemId'] : []
                                }
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_FORMULARIO}
                                deshabilitado={
                                    !documento ||
                                    (estadoDetallesFormulario === EstadosDetallesFormulario.CREACION &&
                                        !documento.ListaAcciones.PermiteAgregarDetalle)
                                }
                                detalleInicialEdicion={detalleInicialEdicion}
                                documentoId={documento ? documento.DocumentoId : ''}
                                editarDetalle={editarDetalle}
                                entidades={entidadesDetalle}
                                estado={estadoDetallesFormulario}
                                tipoCantidad="CantidadRecibida"
                                seriadoConsulta={false}
                                documentoDetallesBase={detallesDocumentoBase}
                                esEntradaInventario={true}
                                bloquearCantidadSerial={true}
                                esOrdenTraslado={false}
                                consultarItems={consultarItemsTabla}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TablaDetalles
                            camposOcultar={CAMPOS_OCULTAR_DETALLES_TABLA}
                            detalles={detalles}
                            editarDetalle={(detalle: IDocumentoDetalleConsultaGeneral) =>
                                setDetalleInicialEdicion(detalle)
                            }
                            editarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEditarDetalle : false
                            }
                            eliminarDetalle={confirmarEliminarDetalle}
                            eliminarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEliminarDetalle : false
                            }
                            mostrarAcciones={
                                estado === EstadosModalEntradaInventario.CREACION ||
                                estado === EstadosModalEntradaInventario.EDICION
                            }
                            recargarTabla={consultarDetalles}
                            titulo={
                                <Texto fontWeight="bold" id="ModalEntradaInventario.TituloTablaDetallesDocumento" />
                            }
                        />
                    </Grid>
                    {abrirModalActa && (
                        <Grid item xs={12}>
                            <DocumentoFirma
                                consultarFirmas={consultarFirmas}
                                guardarFirmas={guardarFirmas}
                                idDocumento={documento ? documento.DocumentoId : ""}
                                cerrarDocumentoFirma={cerrarDocumentoFirma}
                            />
                        </Grid>)

                    }
                    <Grid item xs={12}>
                        <DocumentoValorTotal detalles={detalles} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ModalEntradaInventario;
